import { ISourcingToolSearchFilter } from "react-migration/domains/search/typings/SourcingToolSpecificFilterTypes";
import { agriculturalLandClassificationOptions } from "./agriculturalLandClassificationOptions";
import { SearchType } from "react-migration/domains/search/constants/searchTypes";
import { ConstrainedListFilterMust } from "react-migration/domains/search/typings/SourcingToolFilters/types";

export const AgriculturalLandClassificationFilter: ISourcingToolSearchFilter = {
  id: "agricultural-land-classification-id",
  type: "checkbox",
  field: "sidebar.react.search_sidebar.agricultural_land_classifications",
  must: ConstrainedListFilterMust.MATCH_ANY,
  mustOptions: [ConstrainedListFilterMust.MATCH_ANY, ConstrainedListFilterMust.MATCH_NONE],
  updateFilterDialogIsVisible: false,
  values: agriculturalLandClassificationOptions,
  searchTypes: [SearchType.SOURCING_TOOL_UK],
};
